<div class="overlay">
    <!-- <mat-progress-bar class="progress-bar" [color]="color" [mode]="mode" [value]="value" [bufferValue]="bufferValue"></mat-progress-bar> -->
    <mat-progress-spinner class="progress-bar" 
        [color]="color" 
        [mode]="mode" 
        [value]="value" diameter="28">
    </mat-progress-spinner>
</div>